import { Currency } from '@/core/currency/interfaces';

const HKD: Currency = {
    name: 'Hong Kong Dollar',
    demonym: 'Hong Kong',
    majorSingle: 'Dollar',
    majorPlural: 'Dollars',
    codeNumeric: '344',
    symbol: 'HK$',
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'HKD',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default HKD;
